const people = [
	{
		id: 1,
		image:
			"https://res.cloudinary.com/engineeringwitharavind/image/upload/v1618504099/Balaji-SCI-BI_cc5cjn.jpg",
		name: "Balaji Pichumani",
		title: "Managing Director @ SCI-BI",
		quote:
			"Aravind is a strong developer with great work ethics. During his tenure at SCI-BI he worked on some of our complex projects and exceeded expectations every single time. He has a penchant for good UI/UX which was visible from the work he did for our products. I would strongly recommend Aravind to be a part of any web development team and will be happy to have him on our side in any project.",
	},
	{
		id: 2,
		image:
			"https://res.cloudinary.com/engineeringwitharavind/image/upload/v1618504099/Kishore-Redington_qlkujp.jpg",
		name: "Kishore Jayadeva",
		title: "Head of Analytics @ Redington Cloud",
		quote:
			"I had the opportunity to work with Aravind for over a year. He has good knowledge of Python, Pyspark, and Web applications. He is a trustworthy, talented, dependable member of the team and executes the assigned projects well. I wish him all the best in his professional journey.",
	},
	{
		id: 3,
		image:
			"https://res.cloudinary.com/engineeringwitharavind/image/upload/v1618504099/Nitesh-Redington_bnd8bk.jpg",
		name: "Nitesh Mutkekar",
		title: "Senior Data Scientist @ Philips",
		quote:
			"Aravind was a fantastic colleague to work with, and is not only a multi-skilled and insightful colleague, but also a very good person. Aravind is very hardworking and extremely talented. Aravind is always focused with a very strong problem solving, programming skills and dedicated to excellence. With skills like yours, you don't need luck. And here’s wishing you the very best for all the new ventures.",
	},
	{
		id: 4,
		image:
			"https://res.cloudinary.com/engineeringwitharavind/image/upload/v1618504099/Gopal-Madbee_yuthgs.jpg",
		name: "Gopal Seetharaman",
		title: "Founder & CEO @ Madbee",
		quote:
			"Hey Aravind, Punctuality was one of your best traits that I would greatly appreciate. I am sure it will take you a long way. Of course, I should mention your good understanding of client's needs, which helped you design the right kind of data visualisation, using your excellent skills in data tools. Wish you all the very best, Aravind.",
	},
];

export default people;
